import { render, staticRenderFns } from "./amend-success.html?vue&type=template&id=ae5d8580&scoped=true&external"
import script from "./amend-success.js?vue&type=script&lang=js&external"
export * from "./amend-success.js?vue&type=script&lang=js&external"
import style0 from "./amend-success.scss?vue&type=style&index=0&id=ae5d8580&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5d8580",
  null
  
)

export default component.exports